import useCreateGoogleTagManagerScript from '../useCreateGoogleTagManagerScript';
import useTrackGtmAccountLogin from '../useTrackGtmAccountLogin';

const GoogleTagManagerScript = () => {
  useCreateGoogleTagManagerScript();
  useTrackGtmAccountLogin();
  return null;
};

export default GoogleTagManagerScript;
